


















import { ref, defineComponent, inject } from '@vue/composition-api'

import VolumeForm from './VolumeForm.vue'
import CloseButton from '@/components/custom/CloseButton.vue'
import { createVolume } from '@/shared/api'
import { alertSymbol } from '@/shared/state-management/symbols'

export default defineComponent({
  name: 'CreateVolume',
  components: {
    VolumeForm,
    CloseButton,
  },
  props: {
    textbook: Object,
  },
  setup(props, context) {
    const loading = ref(false)
    const $alert = inject(alertSymbol) as Function

    const submit = async (formData: Record<string, string>) => {
      loading.value = true
      try {
        const createdVolume = await createVolume(props.textbook.id, formData)
        context.emit('volume-created', createdVolume)
        $alert({
          text: context.root.$t('volume.created'),
          type: 'success',
        })
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    return {
      loading,
      submit,
    }
  },
})
